import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DigitalCourseService {

  private coursesSimsave = [
    {
      image: '../../../assets/acls_simsave.png',
      url_login: 'http://aclsctemer.simsave.com.br/login',
      url_register: 'http://aclsctemer.simsave.com.br/register',
      slug: 'preparatorio-acls-simsave',
      name: 'Preparatório ACLS',
      target_audience: 'Estudantes e profissionais da Enfermagem, Medicina e áreas da saúde que atuam em urgência, Emergência ou UTI.',
      description: 'Curso online para estudantes e profissionais da saúde que desejam se preparar para a certificação ACLS com segurança e praticidade.<br><br><b>O que você vai aprender</b><br>• Abordagem inicial do paciente grave<br>• Suporte básico de vida<br>• Ritmos de PCR: chocáveis e não chocáveis<br>• Uso do desfibrilador e cardioversor<br>• Cuidados pós-parada<br>• Síndrome coronariana aguda e AVC<br>• Revisão geral em 20 minutos<br><br><b>Você recebe</b><br>• Acesso por 3 meses<br>• Aulas em vídeo<br>• E-book com 60 questões<br>• Simulador online com diversos cenários<br>• Resumos e mapas mentais<br>',
      class_time: '',
      value: 'De R$ 499,00 por R$ 347,00',
      
    },
     {
      image: '../../../assets/pals_simsave.png',
      url_login: 'http://palsctemer.simsave.com.br/login',
      url_register: 'http://palsctemer.simsave.com.br/register',
      slug: 'preparatorio-pals-simsave',
      name: 'Preparatório PALS',
      target_audience: 'Estudantes e profissionais da Enfermagem, Medicina e áreas da saúde que atuam ou desejam atuar com atendimento de urgência pediátrica.',
      description: 'Curso online essencial para quem busca aprender ou revisar os principais temas do atendimento pediátrico de emergência, com foco na certificação PALS.<br><br><b>O que você vai aprender</b><br>• Abordagem do paciente pediátrico grave<br>• Suporte básico e avançado de vida em pediatria<br>• Ritmos de PCR em crianças<br>• Choque, bradicardias e taquicardias pediátricas<br>• Cuidados pós-PCR<br>• Ventilação, acesso intraósseo e desfibrilação<br><br><b>Você recebe</b><br>• Acesso por 3 meses<br>• Aulas em vídeo (teoria e prática)<br>• Simulador online com cenários interativos<br>• E-book com 50 questões comentadas<br>• Resumos ilustrados e mapas mentais<br>',
      class_time: '',
      value: 'De R$ 499,00 por R$ 347,00',
      
    },
     {
      image: '../../../assets/ecg_simsave.png',
      url_login: 'http://ecgctemer.simsave.com.br/login',
      url_register: 'http://ecgctemer.simsave.com.br/register',
      slug: 'eletrocardiograma-simsave',
      name: 'Eletrocardiograma no Adulto',
      target_audience: 'Estudantes e profissionais da Medicina, Enfermagem e áreas da saúde que atuam ou desejam atuar em UTI, emergência, enfermaria e pronto atendimento.',
      description: 'Aprenda a interpretar ECG no adulto com segurança, clareza e foco clínico. Curso ideal para profissionais e estudantes da saúde que desejam entender desde o ECG normal até ritmos de PCR e arritmias complexas.<br><br><b>O que você vai aprender</b><br>• Princípios básicos e traçado normal<br>• Ritmos de PCR e reconhecimento de traçados<br>• Taquiarritmias e bradicardias<br>• Bloqueios e marca-passo transcutâneo<br>• Sobrecargas e síndrome coronariana aguda<br>• ECG em situações especiais',
      class_time: '',
      value: 'Preço promocional: R$ 347',
      
    },
     {
      image: '../../../assets/vmp_simsave.png',
      url_login: 'http://vmpctemer.simsave.com.br/login',
      url_register: 'http://vmpctemer.simsave.com.br/register',
      slug: 'ventilacao-mecanica-pediatra-simsave',
      name: 'Ventilação Mecânica em Pediatria e Neonatologia – Curso Online',
      target_audience: 'Estudantes de Medicina, Enfermagem, Fisioterapia e profissionais que atuam ou desejam atuar em UTIs pediátricas e neonatais.',
      description: 'Curso online completo para profissionais e estudantes que desejam entender de forma clara e aplicada o uso da ventilação mecânica em crianças e recém-nascidos.<br><br><b>O que você vai aprender</b><br><br><b>Fundamentos da ventilação pediátrica</b><br>• Fisiologia respiratória aplicada<br>• Oxigenioterapia e princípios básicos<br>• Modos ventilatórios convencionais<br><br><b>Casos clínicos e estratégias práticas</b><br>• Ventilação na asma grave e bronquiolite<br>• Ventilação na síndrome do desconforto respiratório agudo (SDRA)<br>• Manejo de crianças cardiopatas<br>• Ventilação protetora e complicações mais comuns<br>• Desmame, extubação e cuidados com traqueostomia<br>• Ventilação não invasiva: quando e como usar<br><br><b>Neonatologia aplicada</b><br>• Assistência ventilatória no recém-nascido<br>• SDRA no RN: como abordar<br>• Hipertensão pulmonar persistente no RN<br>',
      class_time: '',
      value: 'R$ 347 à vista',
      
    },
     {
      image: '../../../assets/vma_simsave.png',
      url_login: 'http://vmactemer.simsave.com.br/login',
      url_register: 'http://vmactemer.simsave.com.br/register',
      slug: 'ventilacao-mecanica-adulto-simsave',
      name: 'Ventilação Mecânica no Adulto – Curso Online',
      target_audience: 'Estudantes de Medicina, Enfermagem, Fisioterapia e profissionais que atuam ou desejam atuar em UTIs',
      description: 'Curso essencial para estudantes e profissionais da saúde que desejam compreender, de forma objetiva e prática, os principais modos e aplicações clínicas da ventilação mecânica em adultos.<br><br><b>O que você vai aprender</b><br>• Fundamentos da ventilação mecânica<br>• Modo controlado a volume e a pressão<br>• Modo de pressão de suporte<br>• Ajustes e indicações clínicas<br>• Ventilação em doenças obstrutivas<br>• SDRA: abordagem ventilatória<br>• Pneumonia associada à ventilação mecânica<br>• Conceitos de assincronia (teórico)<br><br><b>Você recebe</b><br>• Acesso por 3 meses<br>• Aulas com especialistas da terapia intensiva<br>• Casos clínicos comentados<br>• Questionários para fixação<br>• Certificado ao final<br>',
      class_time: '',
      value: 'R$ 347 à vista',
      
    },
     {
      image: '../../../assets/antibiotico.png',
      url_login: 'http://antibioticoctemer.simsave.com.br/login',
      url_register: 'http://antibioticoctemer.simsave.com.br/register',
      slug: 'antibiotico-simsave',
      name: 'Antibioticoterapia',
      target_audience: 'Médicos generalistas, Clínicos, Intensivistas, Emergencistas e Alunos de medicina.',
      description: 'O Curso é 100% online, com aulas nas quais os Antibióticos são apresentados à luz de casos clínicos.',
      class_time: '4H',
      value: 'R$ 279,00 no boleto à vista',
      
    },
  ];

  constructor() {}

  getCourses() {
    return this.coursesSimsave;
  }

  getCourseBySlug(slug: string) {
    return this.coursesSimsave.find(course => course.slug === slug);
  }
}
